export const ZOOM_OFFSET = 1;
export const ZOOM_TRANSITION = 14;
